import { setProcessingState } from 'actions/processing/actions'
import { ActionType, getType } from 'typesafe-actions'

export const reducer = (
  state: boolean = false,
  action: ActionType<typeof setProcessingState>
) => {
  if (action.type === getType(setProcessingState)) {
    return action.payload
  }

  return state
}
